export default "__VITE_ASSET__bcf2fce3__"